import { Locale, type Localized } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: Localized<string> = {
	[Locale.cs]: "/eticky-kodex",
};

export function getCodeOfConductPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
